module.exports = __webpack_public_path__ + "img/vote-unify.518bd6cb.png";